// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresGuestCreateBody = {
  poolId: string;
  firstName: string;
  lastName: string;
  initials: string;
};

export type typeSquaresGuestCreateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    guest: {
      guestId: string;
      firstName: string;
      lastName: string;
      initials: string;
      displayName: string;
    };
  };
};

export type typeSquaresGuestCreateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGuestCreateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGuestCreateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresGuestCreateBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    firstName: { type: "string", maxLength: 3000, minLength: 1 },
    lastName: { type: "string", maxLength: 3000, minLength: 1 },
    initials: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "firstName", "lastName", "initials"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresGuestCreate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresGuestCreateBody);
  }

  return async function postSquaresGuestCreate(
    payload: typeSquaresGuestCreateBody,
  ): Promise<
    typeSquaresGuestCreateOutput200 | typeSquaresGuestCreateOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresGuestCreate" failed before calling the network. #664f632c3279`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#664f632c3279" },
        },
        data: null,
      } as typeSquaresGuestCreateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/guest-create`,
      httpMethod: "POST",
      options,
    })) as typeSquaresGuestCreateOutput200 | typeSquaresGuestCreateOutput400;
  };
}
